const name = "THETA_WALLET";

export const UPDATE_THETA_WALLET_STATE = `${name}/UPDATE_THETA_WALLET_STATE`;
